import { styled } from '@mui/material';
import Slider from '@mui/material/Slider';
import { COLORS } from '~/data/ui/colors';
import { Box } from '@mui/system';

export const useStyles = () => ({
  budgetInputsContainer: {
    width: '100%',
    margin: 'auto',
    flexDirection: 'column',
    gap: '22px',
  } as const,
  divider: {
    width: '13px',
    backgroundColor: 'black',
    marginTop: '20px',
  },
});

export const valueStyle = {
  width: '100%',
  '& > div': {
    width: '100%',
    '& > input': {
      padding: '0 16px',
      height: '48px',
    },
  },
};

export const InputsWrapper = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyItems: 'center',
  gap: '10px',
  '& > div': {
    flex: '1',
  },
});

export const ProgressBarStyle = styled(Slider)(() => ({
  '& .MuiSlider-markLabel': {
    color: COLORS.black.main,
    '&[data-index="1"]': {
      marginLeft: -15,
    },
  },
  '& .MuiSlider-thumb': {
    height: '24px',
    width: '0px',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
    },
    pointerEvents: 'auto !important',
    transform: 'translate(50%, -50%)', // Adjust thumb positioning for RTL direction
  },
  '& .MuiSliderTrack': {
    height: 4,
    color: COLORS.primary.dark,
  },
  '& .MuiSlider-rail': {
    color: COLORS.gray.light2,
    opacity: 1,
  },
  '& .MuiSlider-thumb::after': {
    width: '20px',
    height: '20px',
    background: COLORS.gray.light8,
    border: `4px solid ${COLORS.primary.main}`,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.14)',
  },
  '& .MuiSlider-valueLabel': {
    top: '-25px',
    background: COLORS.primary.light,
    color: COLORS.primary.dark,
    fontSize: '14px',
    height: '41px',
    width: '80px',
    border: `1px solid ${COLORS.primary.main}`,
    borderRadius: '3px',
  },
  '& .MuiSlider-valueLabel::before': {
    borderRight: `1px solid ${COLORS.primary.main}`,
    borderBottom: `1px solid ${COLORS.primary.main}`,
  },
}));

export const sliderStyle = {
  color: `${COLORS.primary.main}`,
  width: '90%',
  alignSelf: 'center',
};
